module.exports = __webpack_public_path__ + "img/787d6e0.png";